
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import { GridSettings } from "@/utils/documents/grid-settings";
import Vue from "vue";
import { LayoutEditorEventBus } from "./layout-editor-event-bus";

export default Vue.extend({
	data(){
		return {

		};
	},
	props: {
		zoomLevel: Number,
		showGrid: Boolean,
		pageSettings: {
			type: Object as () => DocumentPageSettings,
			required: true
		},
		gridSettings: {
			type: Object as ()=>GridSettings,
			default: ()=>new GridSettings()
		}
	},
	computed: {
		dragging():boolean {
			return LayoutEditorEventBus.dragging;
		},
		width(): number {
			return this.pageSettings.Width;
		},
		height(): number {
			return this.pageSettings.Height;
		},
		transform(): string {
			let val = this.zoomLevel / 100.0;
			return `scale(${val})`;
		},
		minRootWidth(): string {
			let val = (this.width * this.zoomLevel) / 100.0;
			return `${val}mm`;
		},
		minRootHeight(): string {
			let val = (this.height * this.zoomLevel) / 100.0;
			return `${val}mm`;
		},
		margin(): string {
			let pageSettings = this.pageSettings;
			let res = `0mm ${pageSettings.MarginRight}mm`;
			res += ` ${pageSettings.MarginBottom}mm ${pageSettings.MarginLeft}mm`;
			return res;
		},
		fontFamily(): string {
			return this.pageSettings.DefaultFont;
		},
		fontSize(): string {
			return this.pageSettings.DefaultFontSize + "pt";
		},
		backgroundImage(): string {
			if (this.pageSettings.BackgroundImage == "") {
				return "";
			}
			return `url("${this.pageSettings.getBackgroundImageUrl()}")`;
		},
		pageStyle(): Object {
			return {
				width: this.width + "mm",
				height: this.height + "mm",
				transform: this.transform,
				transformOrigin: "top center",
				fontFamily: this.fontFamily,
				fontSize: this.fontSize,
				backgroundImage: this.backgroundImage,
			};
		},
		innerContainerStyle():Object {
			return {
				width: this.width + "mm",
				height: this.height + "mm",
				padding: this.margin,
				backgroundSize: `${this.gridSettings.CellWidth}mm ${this.gridSettings.CellHeight}mm`,
			};
		}
	},
	watch: {
		zoomLevel: {
			immediate: true,
			handler(zoomLevel: number) {
				LayoutEditorEventBus.zoomLevel = zoomLevel / 100.0;
			}
		}
	},
	methods: {
		onMouseMove(event: MouseEvent) {
			event.preventDefault();
			event.stopPropagation();
			LayoutEditorEventBus.mouseMove(event.clientX, event.clientY);
		},
		onMouseUp(event: MouseEvent) {
			if (event.button == 0) {
				LayoutEditorEventBus.mouseUp();
			}
		}
	},
	created(){
		window.addEventListener("mouseup", this.onMouseUp);
	},
	destroyed(){
		window.removeEventListener("mouseup", this.onMouseUp);
	}
});
